<template>



    <div class="row">
        <div class="col-xl-12 p-0 float-left d-flex align-items-end justify-content-between">
            <p class="tagLine">You Have 1 Hour to edit this domain.Please press back to Domains button after edit.</p>
        </div>
        <div class="col-xl-12 p-0 float-left d-flex align-items-end justify-content-between">
            <div class="green-button domain-left-v1 domain-btn-container">
                <a type="submit" :href="'/domain/list/'+domain.id" class="btn" >
                    Back to domains
                </a>
            </div>


            <div class="green-button domain-right-v1 domain-btn-container">
                <a type="submit" class="btn" target="_blank" :href="'https://'+domain.name">
                    View Site
                </a>
                <a type="submit" class="btn" href="#" @click="saveAllSettings('SAVE')">
                    Save Changes
                    <div class="loader removeLodaer"></div>
                </a>
                <a type="submit" class="btn" href="#" @click="saveAllSettings('PUBLISH')">
                    Save & Publish
                    <div class="loader removeLodaer"></div>
                </a>
                <a type="submit" class="btn" href="#" @click="saveAllSettingsBeta('PUBLISH')">
                    Save & Publish (beta)
                    <div class="loader removeLodaer"></div>
                </a>
            </div>
        </div>
        <div class="domain-tabs col-xl-12 p-0 float-left">

            <div v-if="messageClass!=null">
                <div class="alert" :class="{'alert-success': messageClass, 'alert-danger': !messageClass}" role="alert">
                    {{message}}
                </div>
            </div>

            <ul id="pagesSidebar" class="nav nav-tabs proxima-nova-bold float-left">
                <li class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#config">
                        <figure class="cong-icon mb-0 mr-3"></figure>
                        CONFIG</a
                    >
                </li>
                <li class="nav-item new addPageElement">
                    <a @click="addPage()" class="nav-link" data-toggle="tab" href="#page1"
                    ><img src="/images/plus.png" alt=""
                    /></a>
                </li>
                <li v-for="(page,index) in pages" :key="index" class="nav-item nav_item_custom">
                    <a class="nav-link" data-toggle="tab" :href="'#' + page.name">
                        <figure class="newfile-icon mb-0 mr-3"></figure>
                        {{ page.name }}
                    </a>
                    <span @click="deletePage(index,page.id)" class="close">x</span>
                </li>
            </ul>

            <div class="tab-content background-fff">
                <div class="tab-pane active" id="config">
                    <div id="display_messages" class="alert"></div>
                    <div class="domain-tabs-outer d-flex">
                        <div class="config-setting float-left">
                            <h5 class="proxima-nova-semibold">Standard Settings</h5>
                            <div class="config-setting-inner col-xl-12 float-left">
                                <ul>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Domain</span></label
                                        >
                                        <p class="float-right domain">{{ domain.name }}</p>
                                    </li>
                                    <p class="domain_name_instruction">Domain name without www.</p>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Client</span></label
                                        >
                                        <select disabled="" name="" class="editClient float-right">
                                            <option value="None">None</option>
                                        </select>
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Choose Template</span></label
                                        >
                                        <select name=""  class="template float-right" @change="onChangeTemplate($event)">
                                            <option  v-for="(template,index) in templates" :selected="config.template_id == template.id " :value="template.id" >
                                                {{template.show_name}}</option>
                                        </select>
                                    </li>

                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Contact</span></label
                                        >
                                        <input
                                            class="float-right contact"
                                            name="contact"
                                            type="text"
                                            placeholder="Enter Your Number"
                                            v-model="config.contact"
                                        />
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Company Name</span></label
                                        >
                                        <input
                                            class="float-right"
                                            type="text"
                                            placeholder="Enter Company Name"
                                            v-model="config.company_name"
                                        />
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Disable chat/popup</span></label
                                        >
                                        <input
                                            v-model="config.disable_js_fetch"
                                            class="float-right is_gallery"
                                            type="checkbox"
                                        />
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table upload_img_lbl">
                                            <span class="d-table-cell align-middle">Logotype Header</span>
                                            <span class="d-table-cell align-middle upload_message"
                                            >Upload images size should be less then 1MB and 150px by 70px</span
                                            >
                                        </label>
                                        <div class="logotype-img float-right">
                                            <div class="image-upload float-left">
                                                <input
                                                    name="header-image"
                                                    class="image-header-upload-box"
                                                    type="file"
                                                    @change="uploadImage($event, 'logo_header')"
                                                />
                                                <div class="upload">
                                                    <img
                                                        class="header-profile-pic"
                                                        :src="config.logo_header"
                                                        alt=""
                                                    />
                                                    UPLOAD IMAGE
                                                </div>
                                                <span @click="removeImage($event, 'logo_header')" class="close"
                                                >x</span
                                                >
                                                <!-- image-upload -->
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Chat styles</span></label
                                        >
                                        <textarea
                                            class="float-right ga_js"
                                            name=""
                                            placeholder="Input styles"
                                            v-model="config.chat_style"
                                        ></textarea>
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Insert PW JS</span></label
                                        >
                                        <textarea
                                            class="float-right pw_js"
                                            name=""
                                            placeholder="Insert script"
                                            v-model="config.pw_js"
                                        ></textarea>
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Insert GA JS</span></label
                                        >
                                        <textarea
                                            class="float-right ga_js"
                                            name=""
                                            placeholder="Insert script"
                                            v-model="config.ga_js"
                                        ></textarea>
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle"
                                        >Insert GA Id (Like Placeholder)</span
                                        ></label
                                        >
                                        <textarea
                                            class="float-right ga_id"
                                            name=""
                                            placeholder="UA-000000000-00"
                                            v-model="config.ga_id"
                                        ></textarea>
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle"
                                        >Google Ads Account IDs (comma-separated)</span
                                        ></label
                                        >
                                        <textarea
                                            class="float-right google_ads_accounts"
                                            name=""
                                            placeholder="Insert IDs"
                                            v-model="google_ads_accounts_string"
                                        ></textarea>
                                    </li>
                                </ul>
                                <!-- config-setting-inner -->
                            </div>
                            <!-- config-setting -->
                        </div>
                        <div class="config-setting sidebar-setting float-left">
                            <h5 class="proxima-nova-semibold">Sidebar</h5>
                            <div class="config-setting-inner col-xl-12 float-left">
                                <ul>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle"
                                        >Header goes here</span
                                        ></label
                                        >
                                        <input
                                            class="float-right"
                                            name="custom_embed_01"
                                            type="text"
                                            placeholder="Insert Header Code Here"
                                            v-model="config.custom_embed_01"
                                        />
                                        <textarea
                                            name=""
                                            class="custom_embed_01_text"
                                            placeholder="Text goes here..."
                                            v-model="config.custom_embed_01_text"
                                        ></textarea>
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle"
                                        >Banner text goes here</span
                                        ></label
                                        >
                                        <input
                                            class="float-right"
                                            name="custom_embed_02"
                                            type="text"
                                            placeholder="Insert Banner Code Here"
                                            v-model="config.custom_embed_02"
                                        />
                                        <textarea
                                            name=""
                                            class="custom_embed_02_text"
                                            placeholder="Text goes here..."
                                            v-model="config.custom_embed_02_text"
                                        ></textarea>
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Insert RECO JS</span></label
                                        >
                                        <textarea
                                            class="float-right reco_js"
                                            name=""
                                            placeholder="Insert script"
                                            v-model="config.reco_js"
                                        ></textarea>
                                    </li>

                                    <li>
                                        <input
                                            class="float-right category"
                                            name=""
                                            type="hidden"
                                            value="DOMAINS"
                                        />
                                    </li>

                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Company Number</span></label
                                        >
                                        <input
                                            class="float-right company_number"
                                            name="company_number"
                                            type="text"
                                            placeholder="Enter Company Number"
                                            v-model="config.company_number"
                                        />
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Address</span></label
                                        >
                                        <textarea
                                            name="address"
                                            class="float-right address"
                                            placeholder="Enter Address"
                                            v-model="config.address"
                                        ></textarea>
                                    </li>

                                    <li>
                                        <label class="float-left m-0 d-table upload_img_lbl"
                                        ><span class="d-table-cell align-middle">Banner Image</span
                                        ><span class="d-table-cell align-middle upload_banner_m"
                                        >Upload images size should be less then 1MB and 1920px by 700px</span
                                        ></label
                                        >
                                        <div class="image-upload pageImageContainer float-left">
                                            <input
                                                @change="uploadImage($event, 'banner_image')"
                                                name="banner_image"
                                                class="image-header-upload-box"
                                                type="file"
                                            />
                                            <div class="upload">
                                                <img  :src="config.banner_image" alt=""/>
                                                UPLOAD IMAGE
                                            </div>
                                            <span  @click="removeBannerImageConfig($event, 'banner_image')"
                                                  class="close">x</span>
                                            <!-- image-upload -->
                                        </div>
                                    </li>
                                </ul>
                                <!-- config-setting-inner -->
                            </div>
                            <!-- config-setting -->
                        </div>
                        <div class="config-setting footer-setting float-left">
                            <h5 class="proxima-nova-semibold">Footer</h5>
                            <div class="config-setting-inner col-xl-12 float-left">
                                <ul>
                                    <li>
                                        <label class="float-left m-0 d-table upload_img_lbl"
                                        ><span class="d-table-cell align-middle">Logotype Footer</span>

                                            <span class="d-table-cell align-middle upload_message"
                                            >Upload images size should be less then 1MB and 150px by 70px</span
                                            >
                                        </label>
                                        <div class="logotype-img float-right">
                                            <div class="image-upload float-left">
                                                <input
                                                    name="logo_footer"
                                                    class="image-footer-upload-box"
                                                    type="file"
                                                    @change="uploadImage($event, 'logo_footer')"
                                                />
                                                <div class="upload">
                                                    <img
                                                        class="footer-profile-pic"
                                                        :src="config.logo_footer"
                                                        alt=""
                                                    />
                                                    UPLOAD IMAGE
                                                </div>

                                                <span @click="removeImage($event, 'logo_footer')" class="close"
                                                >x</span
                                                >
                                                <!-- image-upload -->
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Footer Text 1</span></label
                                        >
                                        <input
                                            class="float-right"
                                            name="footer_text_01"
                                            type="text"
                                            placeholder="Footer goes here (ex: Om oss)"
                                            v-model="config.footer_text_01"
                                        />
                                        <textarea
                                            name=""
                                            class="footer_text_01_Text"
                                            placeholder="Text goes here..."
                                            v-model="config.footer_text_01_Text"
                                        ></textarea>
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Footer Text 2</span></label
                                        >
                                        <input
                                            class="float-right"
                                            name="footer_text_02"
                                            type="text"
                                            placeholder="Footer goes here (ex: Om oss)"
                                            v-model="config.footer_text_02"
                                        />
                                        <textarea
                                            name=""
                                            class="footer_text_02_text"
                                            placeholder="Text goes here..."
                                            v-model="config.footer_text_02_text"
                                        ></textarea>
                                    </li>
                                    <li>


                                    <label class="float-left m-0 d-table"><span class="d-table-cell align-middle">Recent Update History</span></label>
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Date</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(user,index) in domainUsers" :key="index" :id="user.id">
                                                    <td>{{ user.user.name }}</td>
                                                    <td>{{ user.date }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </li>
                                </ul>
                                <div class="social-media col-xl-12 p-0 float-left">
                                    <label class="float-left mb-0 d-table"
                                    ><span class="d-table-cell align-middle">Social Media</span></label
                                    >
                                    <ul>
                                        <li class="text-center">
                                            <input type="hidden" class="push_count" value="0"/>
                                            <div class="data_container"></div>

                                            <div class="clearfix"></div>
                                            <div class="outer-figure">
                                                <figure onclick="pushElement()" class="float-none">
                                                    <img src="/images/plus.png" alt=""/>
                                                </figure>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-for="(page,index) in pages" :key="index" :id="page.name" class="tab-pane pages">
                    <div class="domain-tabs-outer d-flex">
                        <div class="text-editor-box float-left">
                            <h5 class="proxima-nova-semibold">Edit {{ page.menu_label }} Page</h5>
                            <editor
                                api-key="5kkko5z0pg79a6drxz7kwdtkbku37luc3djtwlnbtgy18s8h"
                                :init="{
                              height: 500,
                              menubar: false,
                              image_title: true,
                              automatic_uploads: true,
                              relative_urls: false,
                              remove_script_host: false,
                              convert_urls: true,
                              plugins: [
                                'advlist autolink lists link image charmap print preview anchor',
                                'searchreplace visualblocks code fullscreen',
                                'insertdatetime media table paste code help imagetools wordcount'
                              ],
                              /* without images_upload_url set, Upload tab won't show up*/
                              images_upload_handler: images_upload_handler,
                              toolbar:
                                'undo redo | formatselect | bold italic backcolor | \
                                alignleft aligncenter alignright alignjustify | \
                                bullist numlist outdent indent | removeformat | help | link image | code',

                            }"
                                v-model="page.postContent"
                            />
                        </div>

                        <div class="config-setting editor-fields float-left">
                            <div class="config-setting-inner col-xl-12 float-left">
                                <ul>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Menu Permalink</span></label
                                        >
                                        <input
                                            class="float-right pageName"
                                            name=""
                                            type="text"
                                            placeholder="Enter Menu Permalink"
                                            v-model="page.name"
                                        />
                                    </li>

                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Menu Label</span></label
                                        >
                                        <input
                                            class="float-right pageLabel"
                                            name=""
                                            type="text"
                                            placeholder="Enter Menu Label"
                                            v-model="page.menu_label"
                                        />
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Gallery</span></label
                                        >
                                        <input
                                            class="float-right is_gallery"
                                            v-model="page.is_gallery"
                                            :checked="page.is_gallery == 1 ? 'checked' : ''"
                                            name=""
                                            type="checkbox"
                                        />
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Company Field</span></label
                                        >
                                        <input
                                            class="float-right is_gallery"
                                            v-model="page.isCompany"
                                            :checked="page.isCompany == 1 ? 'checked' : ''"
                                            name=""
                                            type="checkbox"
                                        />
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Main Banner</span></label
                                        >
                                        <input
                                            class="float-right is_gallery"
                                            v-model="page.config_banner"
                                            :checked="page.config_banner == 1 ? 'checked' : ''"
                                            name=""
                                            type="checkbox"
                                        />
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle"
                                        >Page Banner Circle Text</span
                                        ></label
                                        >
                                        <input
                                            class="float-right config_circleText"
                                            v-model="page.config_circleText"
                                            :checked="page.config_circleText == 1 ? 'checked' : ''"
                                            name=""
                                            type="checkbox"
                                        />
                                        <input
                                            class="float-right circleText"
                                            name=""
                                            v-show="page.config_circleText == 1 ? 'true' : ''"
                                            type="text"
                                            placeholder="Insert Banner Circle Text Here"
                                            v-model="page.circleText"
                                        />
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle"
                                        >Page Banner Text</span
                                        ></label
                                        >
                                        <input
                                            class="float-right bannerHeading"
                                            name=""
                                            type="text"
                                            placeholder="Insert Banner Code Here"
                                            v-model="page.bannerHeading"
                                        />
                                        <textarea class="bannerText" name="" placeholder="Text goes here..." v-model="page.bannerText"></textarea>
                                        <textarea
                                            class="meta_desription"
                                            name="" v-model="page.meta_desription"
                                            placeholder="Text goes here..."></textarea>
                                    </li>

                                    <li>
                                        <label class="float-left m-0 d-table"
                                        ><span class="d-table-cell align-middle">Page Form</span></label
                                        >
                                        <textarea class="form" name="" v-model="page.form"
                                                  placeholder="Text goes here..."></textarea>
                                    </li>
                                    <li>
                                        <label class="float-left m-0 d-table upload_img_lbl"
                                        ><span class="d-table-cell align-middle">Page Banner Image</span
                                        ><span class="d-table-cell align-middle upload_banner_m"
                                        >Upload images size should be less then 1MB and 1920px by 700px</span
                                        ></label
                                        >
                                        <div class="image-upload pageImageContainer float-left">
                                            <input
                                                @change="uploadBannerImage($event,page, 'bannerImage')"
                                                name=""
                                                class="pageImage"
                                                type="file"
                                            />
                                            <input
                                                name=""
                                                type="hidden"
                                                class="pageImageValue"
                                                v-model="page.bannerImage"
                                            />
                                            <div class="upload">
                                                <img :src="page.bannerImage" alt=""/>
                                                UPLOAD IMAGE
                                            </div>
                                            <span @click="removeBannerImage($event,page, 'bannerImage')"
                                                  class="close">x</span>
                                            <!-- image-upload -->
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue'

    export default {
        props: ["domain","domainUsers"],
        components: {
            'editor': Editor
        },
        data: function () {
            return {
                defaultBannerImag : "https://dashboard.roimedia.group/templates/4/assets/images/banner_img.jpg",
                pages: [],
                config: {},
                templates:[],
                deletePages: [],
                google_ads_accounts_string: "",
                message: "",
                messageClass: null,
                logo_defaults: "https://dashboard.roimedia.group/uploads/1686560857.png",
                domainUsers : [],
            };
        },
        computed: {},

        mounted() {
            this.loadDomainData();
        },
        created() {
            setTimeout( function () {
                this.saveAllSettingsBeta('SAVE');
                window.location = "/domain/list/";
            }.bind(this), 3600000);
        },
        methods: {
            images_upload_handler (blobInfo, success, failure,) {
                var xhr, formData;
                xhr = new XMLHttpRequest();
                xhr.withCredentials = false;

                xhr.open('POST', '/api/save/image');
                function getCookie(name) {
                    const value = `; ${document.cookie}`;
                    const parts = value.split(`; ${name}=`);
                    if (parts.length === 2){
                        return parts.pop().split(';').shift();
                    }
                }
                var token = decodeURIComponent(getCookie("XSRF-TOKEN"));
                xhr.setRequestHeader("X-XSRF-TOKEN", token);

                xhr.onload = function() {
                    var json;

                    if (xhr.status != 200) {
                        failure('HTTP Error: ' + xhr.status);
                        return;
                    }
                    json = JSON.parse(xhr.responseText);

                    if (!json || typeof json.location != 'string') {
                        failure('Invalid JSON: ' + xhr.responseText);
                        return;
                    }
                    success(json.location);

                };

                formData = new FormData();
                formData.append('file', blobInfo.blob(), blobInfo.filename());

                xhr.send(formData);

            },
            onChangeTemplate(event)
            {
                if(confirm("If You Change template you will lost your all pages & content and set to default pages & content."))
                {
                    this.$http.post(`/domain/template/change/`, {
                        domain_id: this.domain.id,
                        newTemplate_id: event.target.value,
                    }).then((res) => {
                        if (res.data.type == 'OK') {
                            this.message = res.data.message;
                            this.messageClass = 1;
                            this.loadDomainData();
                        } else {
                            this.message = res.data.message;
                            this.messageClass = 0;
                        }
                    });
                }

            },

            loadDomainData() {
                this.$http.get(`/api/domain/${this.domain.id}/get`).then((res) => {
                    this.config = res.data?.config?.[0];
                    this.pages = res.data?.pages;
                    this.templates = res.data?.templates;
                    this.google_ads_accounts_string = res.data?.google_ads_accounts_string;
                    this.domainUsers = res.data?.domainUsers;

                });
            },
            deletePage(index, id) {
                if (id != null && id != 'null') {
                    this.deletePages.push(id);
                }
                this.pages.splice(index, 1);
            },
            addPage() {
                this.pages.push({
                    bannerHeading: '',
                    bannerImage: '',
                    bannerText: '',
                    circleText: '',
                    config_circleText: '',
                    created_at: '',
                    domain_id: this.config.domain_id,
                    form: '',
                    id: null,
                    is_gallery:0,
                    config_banner:1,
                    menu_label: '',
                    meta_desription: '',
                    name: 'Demo' + (this.pages.length + 1),
                    position: '',
                    postContent: '',
                });
            },
            uploadImage(e, key) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = (e) => {
                    Vue.set(this.config, key, e.target.result);
                };
            },
            uploadBannerImage(e, obj, key) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = (e) => {
                    Vue.set(obj, key, e.target.result);
                };
            },
            removeBannerImage(e, obj, key) {
                Vue.set(obj, key, '');
            },
            removeImage(e, key) {
                Vue.set(this.config, key, this.logo_defaults);
            },
            removeBannerImageConfig(e, key) {
                Vue.set(this.config, key, this.defaultBannerImag);
            },
            saveAllSettings(type) {
                this.messageClass = null;
                this.$http.post(`/api/domain/${this.domain.id}/update`, {
                    config: this.config,
                    deletePages: this.deletePages,
                    pages: this.pages,
                    type: type,
                    google_ads_accounts: this.google_ads_accounts,
                }).then((res) => {
                    if (res.data.type == 'OK') {
                        this.message = res.data.message;
                        this.messageClass = 1;
                        this.deletePages = [];
                        this.loadDomainData();
                    } else {
                        this.message = res.data.message;
                        this.messageClass = 0;
                    }
                });
            },
            saveAllSettingsBeta(type) {
                this.messageClass = null;
                this.$http.post(`/api/domain/${this.domain.id}/update/beta`, {
                    config: this.config,
                    deletePages: this.deletePages,
                    pages: this.pages,
                    type: type,
                    google_ads_accounts: this.google_ads_accounts,
                }).then((res) => {
                    if (res.data.type == 'OK') {
                        this.message = res.data.message;
                        this.messageClass = 1;
                        this.deletePages = [];
                        this.loadDomainData();
                    } else {
                        this.message = res.data.message;
                        this.messageClass = 0;
                    }
                });
            },

        },

    };
</script>
